import { useEffect } from 'react';

interface IDisposableController {
  init: (boxGroup: string) => void;
  dispose: () => void;
}

export const useDisposableController = <T extends IDisposableController>(controller: T, boxGroup: string): T => {
  useEffect(() => {
    controller.init(boxGroup);
    return (): void => controller.dispose();
  }, [controller, boxGroup]);
  return controller;
};
